export default {"src":"/_next/static/media/foodalley-de-logo.bd681926.svg","height":205,"width":828,"blurWidth":0,"blurHeight":0};